<template>
  <div class="v2-expand pa-3">
    <v-layout row wrap>
      <v-flex xs12 md6>
        <div class="v2-kpi-label mb-2">Payouts</div>
        <v-data-table :headers="payoutHeaders" :items="payouts" hide-actions class="v2-mini">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.total_gross_amount | currency }}</td>
            <td>{{ props.item.total_mgt_fee | currency }}</td>
            <td>{{ props.item.total_net_pay | currency }}</td>
            <td>{{ props.item.pay_date }}</td>
            <td>{{ props.item.numbers_of_transactions == null ? 0 : props.item.numbers_of_transactions }}</td>
          </template>
          <template slot="footer">
            <tr class="font-weight-bold">
              <td>{{ sum('total_gross_amount') | currency }}</td>
              <td>{{ sum('total_mgt_fee') | currency }}</td>
              <td>{{ sum('total_net_pay') | currency }}</td>
              <td>Total</td>
              <td>{{ sum('numbers_of_transactions') }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 md6>
        <div class="v2-kpi-label mb-2">Notes</div>
        <p v-if="!dealNotes.length" class="v2-muted ma-0">There are no notes for this submission</p>
        <div v-else class="v2-notes">
          <v-timeline dense clipped>
            <v-timeline-item v-for="(n, i) in dealNotes" :key="i" small fill-dot :color="n.image_link ? 'white' : 'primary'">
              <img v-if="n.image_link" slot="icon" :src="n.image_link" class="v2-note-avatar" />
              <v-icon v-else slot="icon" small color="white">comment</v-icon>
              <v-chip v-if="n.pinned" small label color="success" text-color="white" class="ml-0">
                {{ n.deal_note_type == 'Ready2Fund' ? 'readytofund' : 'Pinned' }}
                <v-icon small right>flag</v-icon>
              </v-chip>
              <p class="caption v2-muted ma-0">{{ formatDate(n.created_at) }}: {{ n.name }} ({{ n.deal_note_processor_role }})</p>
              <p class="v2-note-body ma-0" v-html="n.deal_user_note"></p>
            </v-timeline-item>
          </v-timeline>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import moment from 'moment'
import { URL } from '../../../../env'

export default {
  props: ['payouts', 'contract_MID'],
  data: () => ({
    dealNotes: [],
    payoutHeaders: [
      { text: 'Gross amount', sortable: false },
      { text: 'Mgt Fee', sortable: false },
      { text: 'Net Pay', sortable: false },
      { text: 'Pay Date', sortable: false },
      { text: 'No. Trans', sortable: false },
    ],
  }),
  mounted() {
    axios
      .get(`${URL}/api/submission_note/submission_notes`, { contract_MID: this.contract_MID, deal_note_type: 'Collection' })
      .then(res => {
        this.dealNotes = _.concat(_.filter(res.data, o => o.pinned == 1), _.filter(res.data, o => !o.pinned))
      })
  },
  methods: {
    sum(key) {
      return _.sumBy(this.payouts, o => (o[key] ? parseFloat(o[key]) : 0))
    },
    formatDate(date) {
      return moment(date).format('L, h:mma')
    },
  },
}
</script>

<style scoped>
.v2-notes { max-height: 370px; overflow-y: auto; }
.v2-note-avatar { height: 24px; width: 24px; border-radius: 50%; }
.v2-note-body { font-size: 13px; word-wrap: break-word; }
</style>
